import { IsNotEmpty, IsNumber, IsString, IsUrl } from 'class-validator';

export class PropertyFileDto {
  @IsString()
  @IsNotEmpty()
  filename!: string;

  @IsNumber()
  @IsNotEmpty()
  size!: number;

  @IsUrl()
  @IsNotEmpty()
  url!: string;
}
